import { NgFor } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbDialogService,
  NbIconModule,
  NbInputModule
} from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { UtilityService } from 'src/app/core/services/utility.service';
import { RouterState } from 'src/app/features/auth/redux/router-state';
import { Drb } from 'src/app/models/drb-models/drb';
import { NgxGenericModalComponent } from 'src/app/shared/ui/ngx-generic-modal/ngx-generic-modal.component';
import { ToggleShow } from 'src/app/shared/ui/spinner/redux/spinner.actions';
import { PostDrb } from '../redux';

@Component({
  selector: 'app-new-drb',
  templateUrl: './new-drb.component.html',
  styleUrls: ['./new-drb.component.css', '../../../shared/common_syles.css'],
  imports: [NbCardModule, NbIconModule, NbButtonModule, FormsModule, NgFor, NbInputModule]
})
export class NewDrbComponent implements OnInit, OnDestroy {
  public username$: Observable<string> = inject(Store).select(RouterState.username);
  private unsubscribe: Subject<void> = new Subject();

  public contributors = ['', ''];
  public username;
  public errorMessage;
  public bundle_name: string;

  constructor(
    private store: Store,
    protected ref: NbDialogRef<NewDrbComponent>,
    private dialogService: NbDialogService,
    private router: Router,
    private utils: UtilityService
  ) {}

  public ngOnInit() {
    this.username$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.username = data));
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public save() {
    const localDrb = new Drb();

    if (this.contributors.every(this.utils.verifyEmail)) {
      if (this.contributors.includes(this.username)) {
        this.errorMessage = this.username + $localize` is already the Owner.`;

        return;
      }
      localDrb.owner = this.username;
      localDrb.contributors = this.contributors;

      const draftDrb = {
        created_by: localDrb.owner,
        contributors: localDrb.contributors.filter((n) => n),
        bundle_name: this.bundle_name
      };

      this.store.dispatch(new PostDrb(draftDrb, this.bundle_name));
      this.store.dispatch(ToggleShow);

      this.ref.close();
    } else {
      this.errorMessage = $localize`Please enter valid contributor email address. name@irobot.com`;
    }
  }

  public close() {
    this.dialogService
      .open(NgxGenericModalComponent, {
        context: {
          title: $localize`Confirm Close`,
          message: $localize`Are you sure that you want to close the window? Any changes that you have made will be lost and you will be redirected to View section.`
        }
      })
      .onClose.subscribe((data) => {
        if (data) {
          this.router.navigate(['/drb/' + this.bundle_name + '/view']);
          this.ref.close();
        }
      });
  }

  public trackByIndex(index: number, obj: any): any {
    return index;
  }
}
